<template>
  <div class="flex flex-col">
    <div
      v-for="(button, buttonIndex) in message.data.content[0].buttons"
      :key="`button-${buttonIndex}`"
    >
      <el-button
        v-if="
          !((button.type && button.type === 'website') || button.url) ||
          isDisabledButton(button) ||
          button.popupWindow?.enabled
        "
        plain
        v-html="button.text"
        size="small"
        class="message-bubble-button"
        :class="{ 'blue-button': buttonOutline === 'primary' }"
        :type="buttonOutline"
        :disabled="isDisabledButton(button)"
        @click="onClick($event, button)"
      ></el-button>
      <a v-else :href="validUrl(button.url)" :target="button.popup ?? '_blank'">
        <el-button
          plain
          v-html="button.text"
          size="small"
          class="message-bubble-button"
          :class="{ 'blue-button': buttonOutline === 'primary' }"
          :type="buttonOutline"
          @click="onClick($event, button)"
        ></el-button>
      </a>
    </div>
  </div>
</template>

<script>
import _ from "lodash-es";
import isDisabledButton from "@/helpers/isDisabledButton";
import validUrl from "@/helpers/validUrl";

export default {
  props: ["message", "buttonOutline", "shouldDisableIfInLivechat"],
  computed: {
    /**
     * @description Most of the webchat config
     * @return {any}
     */
    settings() {
      return this.$store.getters.settings;
    },
  },
  methods: {
    validUrl,
    isDisabledButton(button) {
      return isDisabledButton(this, button);
    },
    onClick($event, button) {
      const isUpload =
        button.text.toLowerCase().indexOf("upload") > -1 &&
        button.text.toLowerCase() !== "upload documents";
      if (isUpload) {
        this.$root.$emit("upload", button);
      } else {
        // Handle popup window with custom dimensions
        if (button.url && button.popupWindow?.enabled) {
          $event.preventDefault();
          const width = button.popupWindow.width || 500;
          const height = button.popupWindow.height || 600;
          const windowFeatures = `width=${width},height=${height}`;
          window.open(this.validUrl(button.url), "_blank", windowFeatures);
        }
        const _button = {
          ...button,
          $event,
        };
        this.$emit("sendPostback", _button);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message-bubble-button {
  font-family: var(--keyreply-font-family);
}

.ui-beta {
  .message-bubble-button {
    // width: auto !important;
    word-wrap: break-word;
    font-size: 12px !important;
    border-radius: 8px;
    line-height: 16px;
    margin: 0 0 10px 0;
    white-space: normal;
    width: 100%;

    &.blue-button {
      border: 1px solid #4e6cce;
      color: #4e6cce;
      background: #fff;

      &:hover {
        color: #fff;
        background: #4e6cce;
      }
    }
  }
}
</style>
